import React, { useState, Fragment, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { store } from './AddOrEdit';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  extendedForm: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));

const ExtendedForm = () => {
  const classes = useStyles();
  const { state, dispatch, validation } = useContext(store);
  const { values, error } = state;

  const handleChangeTF = (e) => {
    let { name, value } = e.target;
    dispatch({ type: 'CHANGE_FIELD', payload: { [name]: value } });
  };
  const handleChangeCB = (e) => {
    let { checked, name } = e.target;
    dispatch({ type: 'CHANGE_FIELD', payload: { [name]: checked } });
  };
  return (
    <Fragment>
      <div className={classes.extendedForm}>
        <FormControlLabel
          control={
            <Checkbox
              checked={values.isVIP}
              onChange={handleChangeCB}
              name="isVIP"
            />
          }
          label="مشتری ویژه؟ (V.I.P)"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={values.legal}
              onChange={handleChangeCB}
              name="legal"
            />
          }
          label="مشتری حقوقی؟ (شرکت ها)"
        />
        {!values.legal ? null : (
          <Fragment>
            <TextField
              name="company"
              label="نام شرکت"
              value={values.company || ''}
              onChange={handleChangeTF}
              onBlur={validation}
              error={!!error.company || false}
              helperText={error.company || null}
              fullWidth
              variant="outlined"
              size="medium"
            />
            <TextField
              name="companyNationalCode"
              label="شناسه‌ ملی شرکت"
              value={values.companyNationalCode || ''}
              onChange={handleChangeTF}
              onBlur={validation}
              error={!!error.companyNationalCode || false}
              helperText={error.companyNationalCode || null}
              fullWidth
              type="number"
              variant="outlined"
              size="medium"
            />
            <TextField
              name="phone"
              label="شماره تلفن شرکت"
              value={values.phone || ''}
              onChange={handleChangeTF}
              onBlur={validation}
              error={!!error.phone || false}
              helperText={error.phone || null}
              fullWidth
              variant="outlined"
              size="medium"
              type="number"
            />
            <TextField
              name="address"
              label="آدرس دفتر شرکت"
              value={values.address || ''}
              onChange={handleChangeTF}
              onBlur={validation}
              error={!!error.address || false}
              helperText={error.address || null}
              fullWidth
              variant="outlined"
              size="medium"
              multiline
              rows={3}
            />
            <TextField
              name="zipcode"
              label="کدپستی"
              value={values.zipcode || ''}
              onChange={handleChangeTF}
              onBlur={validation}
              error={!!error.zipcode || false}
              helperText={error.zipcode || null}
              fullWidth
              variant="outlined"
              size="medium"
              type="number"
            />
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

export default ExtendedForm;
